import { Injectable } from '@angular/core';
import { StatusBar } from '@capacitor/status-bar';

@Injectable({
  providedIn: 'root',
})
export class StatusBarService {
  setOverlaysWebView(overlay: boolean): void {
    StatusBar.setOverlaysWebView({ overlay });
  }
}
